import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';
import { endSessionOnServer } from './connection/session';

const MsalEventHandler = () => {
  const { instance } = useMsal();

  useEffect(() => {
    const callbackId = instance.addEventCallback(async (event: any) => {
      // Handle login failures or interaction-required errors
      if (
        (event.eventType === EventType.LOGIN_FAILURE ||
          event.error?.errorCode === 'interaction_required') &&
        window.location.pathname !== '/login'
      ) {
        await endSessionOnServer();
        sessionStorage.clear();
        // await instance.logoutRedirect({
        //   postLogoutRedirectUri: '/',
        //   account: instance.getAccountByHomeId(instance.getActiveAccount()?.homeAccountId ?? ''),
        // });
      }

      // Set active account after successful login
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
        instance.setActiveAccount(event.payload.account);
      }
    });

    // Cleanup on unmount
    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance]);

  return null; // This component doesn't render anything
};

export default MsalEventHandler;
